import { createSlice } from '@reduxjs/toolkit';

export interface Slice {
  headers: Headers | void;
}

const initialState: Slice = { headers: undefined };

const slice = createSlice({
  name: 'requestHeaders',
  initialState,
  reducers: {},
});

export default slice;
